import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[prepPageLayout],prep-page-layout',
  host: {
    class: 'prep-page-layout'
  }
})
export class PageLayoutDirective {

  @Input() mode: 'card' | 'simple' = 'simple';

  constructor() { }

  @HostBinding('class.prep-page-layout-card')
  get isCard() {
    return this.mode === 'card';
  }

  @HostBinding('class.prep-page-layout-simple')
  get isSimple() {
    return this.mode === 'simple';
  }

}
